/**
 * [2026-09-10] EVS 웹사이트 약관·방침 콘텐츠 (회원가입 [자세히 보기] 모달·정책 페이지 공용).
 *
 * ★법적 고지(중요):
 *   - 본 문서는 EVS가 웹사이트에서 ★실제로 수집·이용하는 항목★(server/schema.sql 실측: 아이디·비밀번호(해시)·
 *     이름·휴대폰·이메일(선택)·약관동의이력·접속 IP·SMS 인증기록)에 근거해 표준 구조로 작성한 ★초안★이다.
 *   - 최종 게시 전 반드시 회사(법무 담당/변호사) 검토가 필요하다. AI 작성물은 법적 효력을 보증하지 않는다.
 *   - [회사 확인] 표시는 회사만 아는 확정 정보(상호·대표·주소·보호책임자 연락처 등)로 ★채워야 하는★ 자리.
 *   - 표준 근거: 개인정보 보호법 §30(처리방침) / 개인정보보호위원회·KISA 표준 양식 구조.
 *
 * 버전: 동의 이력(terms_agreement.terms_version / privacy_version)에 기록되는 값과 일치시킬 것(현재 'v1').
 *   내용 개정 시 버전을 올리고(v2 …) 시행일을 갱신 → 기존 동의자와 신규 동의자의 버전이 구분되어야 법적 방어 가능.
 */

export interface LegalDoc {
	id: 'terms' | 'privacy';
	title: string;
	version: string;
	effectiveDate: string;   // 시행일(YYYY-MM-DD)
	sections: { heading: string; body: string[] }[];
}

// 초안 상태를 화면 상단에 노출(회사 검토 전 게시 방지용 배너 문구).
export const LEGAL_DRAFT_NOTICE =
	'본 약관은 초안입니다. 게시 전 회사 검토가 필요하며, [회사 확인] 항목은 확정 정보로 교체되어야 합니다.';

export const TERMS_OF_SERVICE: LegalDoc = {
	id: 'terms',
	title: '이용약관',
	version: 'v1',
	effectiveDate: '[회사 확인: 시행일]',
	sections: [
		{ heading: '제1조 (목적)', body: [
			'본 약관은 이브이에스(이하 “회사”)가 운영하는 웹사이트(이하 “사이트”)에서 제공하는 제품 정보, 체험 신청, 문의·상담, 회원 서비스 등(이하 “서비스”)의 이용조건 및 절차, 회사와 회원의 권리·의무·책임사항을 규정함을 목적으로 합니다.',
		]},
		{ heading: '제2조 (정의)', body: [
			'“회원”이란 본 약관에 동의하고 회사가 정한 절차에 따라 가입하여 서비스를 이용하는 자를 말합니다.',
			'“아이디”란 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인한 문자·숫자의 조합을 말합니다.',
			'본 약관에서 정하지 않은 용어는 관계 법령 및 일반 관례에 따릅니다.',
		]},
		{ heading: '제3조 (약관의 효력 및 변경)', body: [
			'본 약관은 사이트에 게시함으로써 효력이 발생합니다.',
			'회사는 관계 법령을 위반하지 않는 범위에서 약관을 변경할 수 있으며, 변경 시 적용일자와 변경사유를 명시하여 시행일 전에 공지합니다.',
			'회원이 변경 약관에 동의하지 않는 경우 회원 탈퇴를 할 수 있으며, 변경 공지 후에도 계속 이용하는 경우 변경에 동의한 것으로 봅니다.',
		]},
		{ heading: '제4조 (이용계약의 성립)', body: [
			'이용계약은 이용자가 약관에 동의하고 가입 신청을 한 후 회사가 이를 승낙함으로써 성립합니다.',
			'회사는 실명이 아니거나 타인의 정보를 이용한 신청, 휴대폰 본인인증을 완료하지 않은 신청 등에 대해 승낙을 거부하거나 사후에 이용계약을 해지할 수 있습니다.',
		]},
		{ heading: '제5조 (회원의 의무)', body: [
			'회원은 가입 시 사실에 근거한 정보를 제공해야 하며, 아이디·비밀번호의 관리 책임은 회원에게 있습니다.',
			'회원은 자신의 계정을 타인이 이용하도록 하여서는 안 되며, 계정 도용·부정사용을 인지한 경우 즉시 회사에 통지해야 합니다.',
			'회원은 관계 법령, 본 약관, 이용안내 및 회사가 공지한 사항을 준수해야 하며, 회사의 업무를 방해하는 행위를 하여서는 안 됩니다.',
		]},
		{ heading: '제6조 (회사의 의무)', body: [
			'회사는 관계 법령과 본 약관을 준수하며, 안정적인 서비스 제공을 위해 노력합니다.',
			'회사는 회원의 개인정보를 「개인정보처리방침」에 따라 보호합니다.',
		]},
		{ heading: '제7조 (서비스의 제공 및 변경·중단)', body: [
			'회사는 서비스의 내용을 운영상·기술상 필요에 따라 변경할 수 있습니다.',
			'회사는 시스템 점검, 설비 장애, 천재지변 등 부득이한 사유가 있는 경우 서비스의 전부 또는 일부를 일시 중단할 수 있으며, 가능한 경우 사전에 공지합니다.',
		]},
		{ heading: '제8조 (계약 해지 및 이용 제한)', body: [
			'회원은 언제든지 서비스 내 절차를 통해 회원 탈퇴를 신청할 수 있으며, 회사는 관계 법령에 따라 지체 없이 처리합니다.',
			'회사는 회원이 본 약관 또는 관계 법령을 위반한 경우 사전 통지 후(긴급한 경우 사후 통지) 이용을 제한하거나 이용계약을 해지할 수 있습니다.',
		]},
		{ heading: '제9조 (책임의 제한)', body: [
			'회사는 천재지변, 회원의 귀책사유 등 회사의 통제 범위를 벗어난 사유로 발생한 손해에 대하여 책임을 지지 않습니다.',
			'회사는 무료로 제공되는 서비스 이용과 관련하여 관계 법령에 특별한 규정이 없는 한 책임을 지지 않습니다.',
		]},
		{ heading: '제10조 (준거법 및 관할)', body: [
			'본 약관은 대한민국 법령에 따라 규율되고 해석됩니다.',
			'서비스 이용과 관련하여 회사와 회원 간 분쟁이 발생한 경우, 관할은 민사소송법에 따른 법원으로 합니다. [회사 확인: 전속관할 지정 여부]',
		]},
	],
};

export const PRIVACY_POLICY: LegalDoc = {
	id: 'privacy',
	title: '개인정보처리방침',
	version: 'v1',
	effectiveDate: '[회사 확인: 시행일]',
	sections: [
		{ heading: '1. 수집하는 개인정보 항목 및 방법', body: [
			'회사는 회원가입·본인인증·서비스 제공을 위해 다음 항목을 수집합니다.',
			'· (필수) 아이디, 비밀번호(암호화 저장), 이름, 휴대폰번호',
			'· (선택) 이메일, 마케팅 수신동의(SMS·이메일)',
			'· (자동수집/보안) 접속 IP, 서비스 이용기록, SMS 인증 기록',
			'수집 방법: 회원가입 및 서비스 이용 과정에서 이용자가 직접 입력, 휴대폰 문자(SMS) 본인인증.',
		]},
		{ heading: '2. 개인정보의 수집·이용 목적', body: [
			'· 회원 식별 및 관리, 본인 확인(휴대폰 인증), 부정 이용 방지',
			'· 제품 정보 제공, 체험 신청·문의·상담 등 서비스 제공',
			'· (선택 동의 시) 신제품·이벤트 등 마케팅 정보 안내',
		]},
		{ heading: '3. 보유 및 이용 기간', body: [
			'회원의 개인정보는 원칙적으로 회원 탈퇴 시 지체 없이 파기합니다.',
			'다만 관계 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다(예: 통신비밀보호법상 접속기록 등). [회사 확인: 법령별 보존항목·기간 확정]',
		]},
		{ heading: '4. 개인정보의 제3자 제공', body: [
			'회사는 이용자의 개인정보를 본 방침에 명시한 목적 범위를 넘어 제3자에게 제공하지 않습니다.',
			'다만 법령에 근거하거나 수사기관의 적법한 요청이 있는 경우는 예외로 합니다.',
		]},
		{ heading: '5. 개인정보 처리의 위탁', body: [
			'회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁할 수 있습니다.',
			'· 휴대폰 문자(SMS) 인증·발송: (주)솔라피(SOLAPI) — 위탁 목적: 인증번호 및 안내 문자 발송.',
			'위탁계약 시 개인정보가 안전하게 관리되도록 관계 법령에 따라 필요한 사항을 규정합니다. [회사 확인: 수탁사·위탁항목 최종 확정]',
		]},
		{ heading: '6. 정보주체의 권리와 행사 방법', body: [
			'이용자는 언제든지 자신의 개인정보를 조회·수정하거나 회원 탈퇴(동의 철회)를 요청할 수 있습니다.',
			'권리 행사는 서비스 내 기능 또는 개인정보 보호책임자에게 연락하여 할 수 있으며, 회사는 지체 없이 조치합니다.',
		]},
		{ heading: '7. 개인정보의 파기', body: [
			'보유기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.',
			'전자적 파일은 복구가 불가능한 방법으로 삭제하고, 출력물은 분쇄 또는 소각합니다.',
		]},
		{ heading: '8. 개인정보의 안전성 확보조치', body: [
			'· 비밀번호는 복호화가 불가능한 일방향 암호화(해시)로 저장합니다.',
			'· 개인정보에 대한 접근 권한을 최소화하고, 데이터베이스는 외부에서 직접 접근할 수 없도록 분리·통제합니다.',
			'· 접속기록 보관 및 비인가 접근 차단을 위한 기술적·관리적 조치를 시행합니다.',
		]},
		{ heading: '9. 쿠키 등 자동수집 장치', body: [
			'회사는 로그인 유지 등 서비스 편의를 위해 브라우저 저장소를 사용할 수 있으며, 이용자는 브라우저 설정을 통해 저장을 거부할 수 있습니다.',
		]},
		{ heading: '10. 개인정보 보호책임자', body: [
			'회사는 개인정보 처리에 관한 업무를 총괄하는 보호책임자를 지정하고 있습니다.',
			'· 개인정보 보호책임자: [회사 확인: 성명/직위]',
			'· 연락처: [회사 확인: 이메일/전화]',
		]},
		{ heading: '11. 방침의 변경', body: [
			'본 방침은 법령·서비스 변경에 따라 개정될 수 있으며, 개정 시 시행일과 변경내용을 사이트에 공지합니다.',
		]},
	],
};

export const LEGAL_DOCS: LegalDoc[] = [TERMS_OF_SERVICE, PRIVACY_POLICY];
